// extracted by mini-css-extract-plugin
export default {"label":"TextField_label__Xbeil","field":"TextField_field__Ac74Q","text":"TextField_text__4TJ10"};